import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { ConnectionService } from '../../connection.service';
import { ToastrService } from 'ngx-toastr';
import { NgForm, ɵangular_packages_forms_forms_d } from '@angular/forms';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
	selector: 'app-contracts-deployment',
	templateUrl: './contracts-deployment.component.html',
	styleUrls: ['./contracts-deployment.component.css']
})
export class ContractsDeploymentComponent implements OnInit {
	filesdetails: any = {}; tokenname: any; fileData = []; uploaded = false; file: any; fileLength: any; version: any; filePath: any; reader: any; FileName: any; filenames: any; fileSplit: any; lastValue: any; abi: any; byteCode: any; contract_address: any; depltxId: any; error = false; deperror = false; compiled = false; deployed = false; verified = false
	@ViewChild('editor') editor; cmplLoader = false; dplyLoader = false; token = localStorage.getItem('Sastana_Token'); modalRef: BsModalRef;
	userAddress = localStorage.getItem('Address')
	model: any = {}; config: any
	complied: Boolean = false
	content: any;
	balance: any
	contractCode: any;
	tokenObj: any = {}
	myFiles: any[] = [];
	fileType: any = {}
	url: string;
	fileContent: string = '';
	fileversion: string;
	files: File[] = [];
	solversion: any;
	constructorparams: any = {}
	constructorInputs: any;
	sastValue: any
	payableInputs: any;

	constructor(private modalService: BsModalService, private conn: ConnectionService, private alert: ToastrService, private route: Router, private actRoute: ActivatedRoute, private spinner: NgxSpinnerService) {
	}

	ngOnInit() {
		this.getBalance();
	}

	getBalance() {
		this.conn.postUrl('users/userBalance', { address: this.userAddress }).subscribe((res: any) => {
			this.balance = res.data.userBalance;
		})
	}



	getFileDetails(e) {
		this.fileLength = e.target.files.length
		if (this.fileLength < 2) {
			this.alert.error('Maximum two files are required');
		}
		else {
			this.uploaded = true;
			this.files = [];
			const fileList: FileList = e.target.files;
			for (let i = 0; i < fileList.length; i++) {
				this.reader = new FileReader();
				this.file = <Array<File>>e.target.files[0];
				this.filenames = <Array<File>>e.target.files[0].name;
				this.fileSplit = this.filenames.split('.');
				this.lastValue = this.fileSplit.length - 1;
				this.FileName = this.fileSplit[this.lastValue];
				if (this.FileName == 'sol') {
					const file: File = fileList.item(i) as File;
					this.files.push(file);
				}
				else {
					this.alert.error('Invalid Solidity File');
				}
			}
			this.compileSol();

		}
	}

	showFile(event: any, files) {
		this.fileLength = event.target.files.length
		if (this.fileLength > 0) {
		}
		this.reader = new FileReader();
		this.file = <Array<File>>event.target.files[0];
		this.filenames = <Array<File>>event.target.files[0].name;
		this.fileSplit = this.filenames.split('.');
		this.lastValue = this.fileSplit.length - 1;
		this.FileName = this.fileSplit[this.lastValue];

		if (this.FileName == 'sol') {
			this.uploaded = true;
			this.reader.onload = (event) => {
				this.fileContent = this.reader.result
				var finalRes = this.fileContent.split(';')
				var version = finalRes[0].split('^')
				this.fileversion = version[1]
				this.compileSol();
			}
			this.reader.readAsText(this.file);
			this.model.content = this.file
		} else {
			this.uploaded = false;
			this.alert.error('Invalid Solidity File');
		}
	}

	compileSol() {
		this.cmplLoader = true;
		const formData = new FormData();

		if (this.fileType.type == 'single') {
			formData.append('filename', this.filenames);
			formData.append('file', this.model.content);
			formData.append('version', this.fileType.version);
			formData.append('solname', this.fileType.solname)


			this.url = 'wallet/compilesingleSol'
		}
		else {
			for (let file of this.files) {
				formData.append('filename', file.name);
				formData.append('file', file);
			}
			formData.append('version', this.fileType.version);
			formData.append('solname', this.fileType.solname)


			this.url = 'wallet/compilemultiSol'
		}
		this.spinner.show()
		this.conn.postUrl(this.url, formData).subscribe((res: any) => {
			if (res.status == true) {
				this.spinner.hide()

				this.complied = true
				this.abi = res.abi;
				this.error = false;
				this.byteCode = res.data;
				this.contractCode = res.contractFile
				this.solversion = res.version
				this.compiled = true;
				this.alert.success('Compiled Successfully');
				this.getContructorInputs();
				this.getPayableInputs();

			} else {
				this.spinner.hide()
				this.alert.error(res.msg);
				this.error = res.error;
			}
			this.cmplLoader = false;
		})
	}

	async getContructorInputs() {
		this.constructorInputs = this.abi.find(e => e.type === 'constructor')?.inputs;
	}

	async getPayableInputs() {
		this.payableInputs = this.abi.find(e => e.stateMutability === 'payable');
	}

	deploySol() {
		this.dplyLoader = true;
		var data = { 'address': this.userAddress, 'abi': this.abi, 'bytecode': this.byteCode, 'name': this.tokenname, 'confile': this.contractCode , version : this.solversion, values: this.constructorparams}
		this.spinner.show()
		if (this.balance >= 300) {
			this.conn.postUrl('vote/contractDeploy', data).subscribe((res: any) => {
				this.modalRef.hide();
				this.compiled = false;
				this.deployed = true;
				if (res.success == true) {
					this.spinner.hide()
					this.verified = true
					this.depltxId = res.data.Txnid;
					this.contract_address = res.data.address
					this.alert.success(res.msg);
				} else {
					this.spinner.hide()
					this.alert.error(res.msg);
					this.deperror = res.msg;
				}
				this.dplyLoader = false;
			})
		}
		else {
			this.spinner.hide()
			this.modalRef.hide();
			this.alert.error('Insufficient SAST Balance.Minimum 300 SAST is required');
		}
	}

	verifyContract() {
		this.conn.postUrl('vote/contractVerify', { contractAddress: this.contract_address }).subscribe((res: any) => {
			if (res.success == true) {
				this.alert.success(res.msg);
				this.route.navigate(['/contract-methods', res.data.contractAddress, res.data.name, 'contract'])
			}
			else {
				this.alert.error('Contract Verification failed');
			}
		})
	}

	openModal(template: TemplateRef<any>) {
		this.modalRef = this.modalService.show(template);
	}

	deployFunc(depFrom: NgForm) {
		var data = depFrom.value;
		let abi = JSON.stringify(this.abi)
		let bytecode = this.byteCode
		this.tokenname = data.tokenname;
		localStorage.setItem('sastana-ABI', abi);
		localStorage.setItem('sastana-Byte', bytecode);
		this.deploySol();
	}

	copyText(val: string) {
		let selBox = document.createElement('input');
		selBox.value = val;
		document.body.appendChild(selBox);
		selBox.focus();
		selBox.select();
		document.execCommand('copy');
		document.body.removeChild(selBox);
		this.alert.success('Copied to the clipboard');
	}

	copyArrayText(val: string) {
		let value = JSON.stringify(val)
		let selBox = document.createElement('input');
		selBox.value = value;
		document.body.appendChild(selBox);
		selBox.focus();
		selBox.select();
		document.execCommand('copy');
		document.body.removeChild(selBox);
		this.alert.success('Copied to the clipboard');
	}
}


